import PermissionContext from '../../common/components/permissions-context';
import { useContext } from '../../common/hoc/user-context';

export default useContext(PermissionContext);
